import { AccountDetailInfoVO } from '@/@types'
import { MCity, MCurrency } from '@sailor/i18n-web'
import { useRecoilState } from 'recoil'
import {
  accountDetailInfoAtom,
  passportUserInfoAtom,
} from '@/common/recoil/atom'
import mainApi from '@/common/api/urls'
import { DEFAULT_PASSPORT_USERINFO } from '@/common/constants'
import {
  getPassportApiHost,
  isLocal,
  toLogin,
  setLoginUid,
  setLoginUinfo,
  getLoginUinfo,
  setLoginAccountId,
  getCityId,
  getRegionByCookie,
  getCurrency, getLoginBrandInfo,
  getIsOrderManager,
} from '@RootCommon/utils'
import { commonRequest } from '@/common/utils/request'
import { setCookie } from '@utiljs/cookie'
import { setI18nInfos } from '@/common/hooks/useShopInfo'

const isOrderManager = getIsOrderManager()
const urlSearchParams = new URLSearchParams(location.search)
const hideToast = urlSearchParams.get('hideToast') === '1'

// 信息接口顺序：
// updateAccountDetailAndShopInfoV2：账号detail(accountId cityId region) ->
// getAccountShopList：门店shoplist
export default function () {
  const [passportUserInfo, setPassportUserInfo] = useRecoilState(passportUserInfoAtom)
  const [accountDetailInfo, setAccountDetailInfo] = useRecoilState(accountDetailInfoAtom)

  // async function updatePassportUserInfo () {
  //   try {
  //     const accUrl = `//${getPassportApiHost()}${mainApi.getUinfo}`
  //     const params = {
  //       fields: 'id,username,email,mobile,hasPassword,avatartype,avatarurl',
  //     }
  //     const res = await pureRequest.get(accUrl, {
  //       params,
  //       withCredentials: true,
  //     })
  //     const { user, error } = res || {}
  //     const _isLocal = isLocal(window.location.host)
  //     if (!_isLocal && error && +error.code === 401) {
  //       toLogin()
  //       return false
  //     }
  //     const { username, idStr, email, countryCode } = user || {}
  //     const uInfo = { username: email || username || '', email, id: idStr || 0, uid: idStr || '', countryCode }
  //     setPassportUserInfo(uInfo)
  //     setLoginUinfo(uInfo)
  //     setLoginUid(uInfo.uid)
  //     setCookie('accountId', uInfo.uid)

  //     const brandInfo = getLoginBrandInfo() || {}
  //     brandInfo.brandId === '0' && setLoginAccountId(uInfo.uid) // 集团账号-当前有品牌信息时，不能重置为登录账号id

  //     return uInfo
  //   } catch (e) {
  //     console.log('updatePassportUserInfoError', e, DEFAULT_PASSPORT_USERINFO)

  //     // const uInfo = DEFAULT_PASSPORT_USERINFO
  //     const uInfo = {
  //       'id': '4611686018428734904',
  //       'uid': '4611686018428734904',
  //       'email': 'b217008@m.meeta.com',
  //       'idStr': '4611686018428734904',
  //       'mobile': '531***397',
  //       'username': 'oSzs9336',
  //       'avatarurl': '',
  //       'avatartype': 0,
  //       'countryCode': '966',
  //       'hasPassword': 1,
  //       'tokenChannel': 1003,
  //     }
  //     // @ts-ignore
  //     // setPassportUserInfo({ ...uInfo, uid: '0' }) // 账号接口异常，只影响账号名展示。
  //     setPassportUserInfo(uInfo)
  //     setLoginUinfo(uInfo)
  //     setLoginUid(uInfo.uid)
  //     setLoginAccountId(uInfo.uid)
  //     setCookie('accountId', uInfo.uid)
  //     return uInfo
  //   }
  // }

  async function updateShopUserInfo () {
    try {
      const accountInfo = (await commonRequest.get(mainApi.accountDetail, { autoToast: !(isOrderManager || hideToast) }) || {}) as AccountDetailInfoVO
      const { acctId, acctType: accountType } = accountInfo || {}
      const region = accountInfo?.region || process_env_idcDefaultRegion || 'HK'
      const capitalCityId = accountInfo?.capitalCityId || MCity.getCapitalCityIdByRegion(region)
      const storedUinfo = getLoginUinfo()
      const email = accountInfo.email || storedUinfo.email
      const username = accountInfo.username || storedUinfo.username
      const currency = MCurrency.getSymbolByCityId(capitalCityId) || MCurrency.getCurrencyByCityId(capitalCityId)
      const newAccountInfo = {
        ...storedUinfo,
        ...accountInfo,
        username,
        email,
        accountType, id: acctId, uid: acctId,
        region, cityId: capitalCityId, capitalCityId, currency,
      }
      setLoginUid(acctId)
      setLoginUinfo(newAccountInfo)
      setCookie('accountId', acctId)
      setAccountDetailInfo(newAccountInfo)
      setI18nInfos({ region, cityId: capitalCityId, currency, noRefresh: true }) // 立即更新i18n信息，保障门店接口能按区域生效拦截

      const brandInfo = getLoginBrandInfo() || {}
      brandInfo.brandId === '0' && setLoginAccountId(acctId) // 集团账号-当前有品牌信息时，不能重置为登录账号id
      // @ts-ignore
      const tracker = window.LXAnalytics('getTracker')
      // @ts-ignore
      tracker && tracker('set', 'uid', acctId) // 埋点上报修正为真实userid
    } catch (e) {
      console.log(e)
      setAccountDetailInfo({ acctId: '0', accountType: 0, roles: [], region: getRegionByCookie(), capitalCityId: getCityId(), currency: getCurrency() })
    }
  }

  // async function updateAccountShopList () {
  //   try {
  //  } catch (e) {
  //   }
  // }

  return {
    passportUserInfo,
    // updatePassportUserInfo,
    accountDetailInfo,
    updateShopUserInfo,
  }
}
